import Layout from './Layout'
import UsersList from './UsersList';
import { useAuth } from "./AuthProvider";
import Breadcrumbs from './Breadcrumbs';
import { ADMIN } from './Roles';

const Users = () => {
  const auth = useAuth();

  return (
      <Layout>
          <Breadcrumbs />
          {auth.roles.includes(ADMIN) && <UsersList/>}
      </Layout>
    );
};

export default Users;